import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { capitalize } from '../../../../utils/capitalize-string';
import NOB from '../../../../constants/language-strings';
import { isPast } from 'utils/past-due-date';
import styled, { css } from "styled-components";
import { purpurColorFunctionalBlack, purpurColorFunctionalWhite, purpurColorGreen600, purpurColorPurple600, purpurColorRed600, } from '@purpurds/tokens/color/variables';
import spacing from 'theme/spacing';
import { pxToRem } from 'theme/utils';
import { purpurShadowMd } from '@purpurds/tokens/shadow/variables';
import { getIconColor, setStatusTimeValue, setStatusVariant } from 'modules/WorkorderList/helpers';
import Status from '../../../../constants/status-codes';
import { Icon } from '@purpurds/purpur/icon';
import { icons } from 'theme/icons';
export const ListContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-width: ${pxToRem(320)};
  margin: ${spacing.spacing8} 0 ${spacing.spacing16};
`;
export const WorkOrderCard = styled(Link) `
  display: flex;
  flex-wrap: wrap;
  box-shadow: ${purpurShadowMd};
  width: calc(100% - 80px);
  max-width: ${pxToRem(500)};
  min-height: 80px;
  margin-bottom: 6px;
  padding: ${spacing.spacing16} ${spacing.spacing16} ${spacing.spacing12};
  text-decoration: none;
  color: ${purpurColorFunctionalBlack};
  border-radius: 4px;

  ${({ $variant }) => {
    switch ($variant) {
        case "started":
            return css `
          border-left: 6px solid ${purpurColorPurple600};
        `;
        case "cancelled":
            return css `
          border-left: 6px solid ${purpurColorRed600};
          pointer-events: none;
        `;
        case "completed":
            return css `
          background: ${purpurColorFunctionalWhite};
          border-left: 6px solid ${purpurColorGreen600};
        `;
        case "incomplete":
            return css `
          background: ${purpurColorFunctionalWhite};
          border-left: 6px solid ${purpurColorRed600};
        `;
        default:
            return css `
          background: ${purpurColorFunctionalWhite};
          border-left: 6px solid ${purpurColorPurple600};
        `;
    }
}}

  ${({ $warning }) => $warning &&
    css `
      border-left-color: ${purpurColorRed600} !important;
    `}
`;
export const TopLeft = styled.div `
  display: flex;
  flex-direction: column;
  flex: 45%;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: -0.5px;

  .new-text {
    margin-top: ${spacing.spacing4};
    font-weight: normal;
    display: flex;
    align-items: center;
  }
`;
export const TopRight = styled.div `
  span:first-child {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
  }

  span:last-child {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
  }
`;
export const BottomLeft = styled.div `
  display: flex;
  flex: 50%;
  align-self: flex-start;
  margin-top: ${spacing.spacing4};
  width: ${pxToRem(182)};
  font-size: 18px;

  .address {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }

  .postal {
    display: flex;
    flex-direction: column;
  }
`;
export const BottomRight = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  min-width: 100px;
  height: 44px;
  margin-top: ${spacing.spacing4};
  font-size: 18px;

  .warning {
    color: ${purpurColorRed600};
  }
`;
const StyledIcon = styled(Icon) `
  margin-right: ${spacing.spacing4};
  color: ${({ $color }) => $color};
`;
export const WorkOrderList = ({ workOrders }) => {
    const startedStatuses = [...Status.TRAVELING, ...Status.ON_SITE];
    const workOrderStatus = (workOrder) => /\d/.test(workOrder.status)
        ? workOrder.status.slice(workOrder.status.lastIndexOf(" ") + 1)
        : workOrder.status;
    return (_jsx(ListContainer, { children: workOrders.map((workOrder) => {
            const { address: { city, flatOrApartment, houseNumberAlpha, houseNumberNumeric, postalCode, street }, serviceTypeName, workOrderId, serviceDate, customer: { firstName, surname }, } = workOrder;
            const status = workOrderStatus(workOrder);
            const isPastDue = isPast(serviceDate);
            const color = getIconColor(status, isPastDue);
            return (_jsxs(WorkOrderCard, { to: `/workOrder/${workOrderId}`, "$variant": setStatusVariant(startedStatuses, status), "$warning": isPastDue, children: [_jsxs(TopLeft, { children: [_jsx("div", { children: serviceTypeName }), _jsxs("div", { className: "new-text", children: [_jsx(StyledIcon, { svg: icons.endUser, size: 'sm', "$color": color }), firstName, " ", surname] })] }), _jsxs(TopRight, { children: [_jsx("span", { children: `${NOB.WORKORDER_LIST.WORKORDER}: ` }), _jsx("span", { children: workOrderId })] }), _jsxs(BottomLeft, { children: [_jsx(StyledIcon, { svg: icons.home, size: 'sm', "$color": color }), _jsxs("div", { className: "address", children: [_jsxs("div", { children: [capitalize(street), " ", houseNumberNumeric, houseNumberAlpha && ` ${houseNumberAlpha}, `] }), _jsxs("div", { className: "postal", children: [_jsxs("span", { children: [postalCode, " ", capitalize(city)] }), _jsx("span", { children: flatOrApartment })] })] })] }), _jsx(BottomRight, { children: setStatusTimeValue(workOrder, status, isPastDue) })] }, workOrderId));
        }) }));
};
